// Module
var code = "<p>(Coming Soon)</p> <ul> <li> <h4 id=\"provisional_evidence_code_bioinfo\">Provisionally Assigned </h4> (Coming Soon)</li> <li> <h4 id=\"provisional_evidence_description_bioinfo\">Description </h4> (Coming Soon)</li> </ul> ";
// Exports
module.exports = code;